import React, { useRef, useState } from "react"
import axios from "axios"
import styles from '../css/tripAdd.module.css'
import { MdClose } from "react-icons/md"
import { SwitchTransition, CSSTransition } from "react-transition-group"
import { toast } from "react-toastify"


function HikeAdd({fetchHikes, handleCloseForm}) {

  const nodeRef = useRef(null) 

  const [step, setStep] = useState(1) // 1: Trasa, 2: Szczegóły, 3: Użytkownik
  const [textAreaIsFocused, setTextAreaIsFocused] = useState(false);
  const [agreeToPrivacy, setAgreeToPrivacy] = useState(false);

  const [img, setImg] = useState(null)

  const [formHike, setFormHike] = useState({
    destination: '',
    startPoint: '',
    speed: '',
    dateStartHike: '',
    timeStartHike: '',
    userName: '',
    contactPhone: '',          
    contactInsta: '',         
    contactMessenger: '', 
    description: '',
  })


  const isCurrentStepValid =
    (step === 1 && formHike.destination.trim() && formHike.speed.trim()) ||
    (step === 2 && formHike.dateStartHike.trim())

  const minDate = new Date().toISOString().slice(0, 10);

  const isFormValid =
    formHike.userName.trim() &&
    img !== null &&
    (
      formHike.contactPhone.trim() ||
      formHike.contactInsta.trim() ||
      formHike.contactMessenger.trim()
    )

    
  const handleAddHike = async (e)=>{

    e.preventDefault()
   
    // to co w cudzysłowiu , odnosi sie do backednu 
    const formData = new FormData()
    formData.append('destination', formHike.destination)
    formData.append('startPoint', formHike.startPoint)
    formData.append('speed', formHike.speed)
    formData.append('dateStartHike', formHike.dateStartHike)
    formData.append('timeStartHike', formHike.timeStartHike)
    formData.append('userName', formHike.userName)
    formData.append('img', img)
    formData.append('contactPhone', formHike.contactPhone)
    formData.append('contactInsta', formHike.contactInsta)
    formData.append('contactMessenger', formHike.contactMessenger)
    formData.append('description', formHike.description)

    try{
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/upload-hike`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        });

      if(response.data.success){
        toast.success("Dodano wyjście na szlak!")
                fetchHikes()
                setFormHike({
                  destination: "",
                  startPoint: "",
                  speed: '',
                  dateStartHike: "",
                  timeStartHike: "",
                  userName: "",
                  contactPhone: "",
                  contactInsta: "",
                  contactMessenger: "",
                  description: ""
                })
                setImg(null)
                handleCloseForm()
      }
      else{
        alert('Błąd dodawania wyjścia na szlak')
      }

    }
    catch (err) {
          console.log('Błąd:', err)
          toast.error("Wystąpił błąd podczas dodawania wyjścia na szlak.")
    }
  }


  const handleImageChange = (e) => {
    setImg(e.target.files[0])
  }


  const handleOnChange = (e) => {
    const { value, name } = e.target
    setFormHike(prev => ({
      ...prev,
      [name]: value
    }))
  }

  return (
  
    <div className={styles.formContainer}>
  
      <span className={styles.stepInfo}>Krok {step} / 3</span>
  
      <form onSubmit={handleAddHike } method="post" encType="multipart/form-data">
        
        <div className={styles['form-header']}>
  
          {(step === 2 || step === 3) ? (
            <span className={styles['btn-back-top']} onClick={() => setStep(step - 1)}>← Wstecz</span>
            ) : (
            <span className={styles['btn-back-top']} /> // pusty element – żeby X nie przeskakiwał
          )}
          
          <div className={styles['close-btn']} onClick={handleCloseForm}><MdClose /></div>
  
        </div>
  
        {/* TUTAJ DODAJEMY DODATKOWY KONTENER DLA ANIMACJI */}
        <div className={styles.animationWrapper} ref={nodeRef}>
  
          <SwitchTransition mode="out-in">
            <CSSTransition
                  key={step}
                  timeout={200}
                  classNames="step"
                  unmountOnExit
                  mountOnEnter
                  nodeRef={nodeRef}
            >
            <div className={styles.stepContainer}>
  
              {step === 1 ? (
                    
                <div className={styles.step}>
                    
                  {/* KROK 1 – TRASA */}
   
                  <div className={styles['floating-label']}>
                    <input
                      type="text"
                      name="destination"
                      onChange={handleOnChange}
                      value={formHike.destination}
                      placeholder=" "
                      required
                    />
                    <label>Cel wędrówki np.Rysy </label>
                  </div>
  
                  <div className={styles['floating-label']}>
                    <input
                      type="text"
                      name="startPoint"
                      onChange={handleOnChange}
                      value={formHike.startPoint}
                      placeholder=" "
                    />
                    <label>
                      Punkt startowy np. Kuźnice <span className={styles.optionalAreaText}>(Opcjonalne)</span>
                    </label>
                  </div>  

                  <div className={styles.radioGroupWrapper}>
                    <span className={styles.radioGroupLabel}>Tępo </span>
                    <div className={styles.radioGroup}>
                      {['Spokojne 🐌', 'Szlakowe 🐐', 'Szybkie 🐇', 'Obojętne 🤷'].map(option => (
                        <label
                          key={option}
                          className={`${styles.radioLabel} ${formHike.speed === option ? styles.active : ''}`}
                        >
                          <input
                            type="radio"
                            name="speed"
                            value={option}
                            checked={formHike.speed === option}
                            onChange={handleOnChange}
                          />
                          {option}
                        </label>
                      ))}
                    </div>
                  </div>

                </div>
              
              ) : step === 2 ? (
                    
                <div className={styles.step}>
                      
                  {/* KROK 2 – Informacje o Wyjeździe */}
  
                  <div className={styles['floating-label']}>
                    <input
                      type="date"
                      name="dateStartHike"
                      min={minDate}
                      onChange={handleOnChange}
                      value={formHike.dateStartHike}
                      required
                    />
                    <label>Data wyprawy</label>
                  </div>
  
                  <div className={styles['floating-label']}>
                    <input
                      type="time"
                      step="300"
                      name="timeStartHike"
                      onChange={handleOnChange}
                      value={formHike.timeStartHike}
                    />
                    <label>
                      Przewidywana godzina wyjścia <span className={styles.optionalAreaText}>(Opcjonalne)</span>
                    </label>
                  </div>
  
                  <div className={styles['floating-label']}>
                    <textarea
                      name="description"
                      onChange={handleOnChange}
                      value={formHike.description}
                      placeholder=' '
                      maxLength={400}
                      onFocus={() => setTextAreaIsFocused(true)}
                      onBlur={() => setTextAreaIsFocused(false)}
                    />
                    <label>
                      Dodatkowe informacje o wyprawie <span className={styles.optionalAreaText}>(Opcjonalne)</span>
                    </label>
                  </div>
                  {textAreaIsFocused &&
                    <div className={styles['char-counter']}>
                        Znaków:  {formHike.description.length} / 400
                    </div>
                  }

                </div>

              ) : (
                    
                <div className={styles.step}>
                      
                  {/* KROK 3 – Informacje o Użytkowniku */}
  
                  <div className={styles['floating-label']}>
                    <input
                      type="text"
                      placeholder=' '
                      name="userName"
                      onChange={handleOnChange}
                      value={formHike.userName}
                      required
                    />
                    <label>Twoje imię</label>
                  </div>
  
                  <div className={styles.buttonAddImageWrapper}>
  
                    {!img && <p style={{  color: '#2a9d8f', fontFamily: 'inherit' }}>
                      <strong>Twoje zdjęcie</strong>
                    </p>}
                        
  
                    <label htmlFor="file-upload" className={styles['fileUpload']}>
                      Wybierz zdjęcie
                    </label>
  
                    <input
                      id="file-upload"
                      type="file"
                      onChange={handleImageChange}
                      accept="image/*"
                      style={{ display: 'none' }}
                    />
  
                    {img && (
                      <div className={styles.imagePreview}>
                        <img src={URL.createObjectURL(img)} alt="Podgląd" />
                      </div>
                    )}
  
                  </div>
  
                  {/* Kontakt*/}
                      
                  <div className={styles.contactPanel} style={{textAlign: 'left'}}>
  
                    <p style={{ fontSize: '1rem'  }}>
                      <strong style={{color: '#2a9d8f'}}>Kontakt do Ciebie</strong> 
                      <span className={styles.optionalAreaText}>(minimum jedno pole)</span>
                    </p>
  
                    <div className={styles.contact}>
  
                      <input                        
                        type="text"
                        name="contactPhone"
                        onChange={handleOnChange}
                        value={formHike.contactPhone}
                        placeholder="Telefon / WhatsApp"
                      />
                      <input
                        type="text"
                        name="contactInsta"
                        onChange={handleOnChange}
                        value={formHike.contactInsta}
                        placeholder="@instagram"
                      />
                      <input
                        type="text"
                        name="contactMessenger"
                        onChange={handleOnChange}
                        value={formHike.contactMessenger}
                        placeholder='messenger / fb'
                      />
  
                    </div>

                  </div>
       
                  <div style={{ marginTop: '1rem', textAlign: 'center', display: "flex", alignItems:'start',     }}>
        
                    <input
                      id='acceptPolicy'
                      type="checkbox"
                      checked={agreeToPrivacy}
                      onChange={() => setAgreeToPrivacy(!agreeToPrivacy)}
                      style={{ marginRight: '0.5rem' }}
                      required
                    />
                    <label htmlFor="acceptPolicy"  
                    style={{ 
                      fontSize: '0.6rem', 
                      cursor: 'pointer',
                    }}>
                      Wyrażam zgodę na przetwarzanie danych osobowych zgodnie z <a href="/info/polityka-prywatnosci-popup" target="_blank" rel="noopener noreferrer">polityką prywatności</a>.
                    </label>
                  </div>
  
                  <div className={styles['btn-accept-trip-wrapper']}>
                    <button
                      type="submit"
                      className={`${styles.btn} ${styles['btn-accept-form']} ${(isFormValid && agreeToPrivacy) ? styles.show : styles.hide}`}
                      disabled={!(isFormValid && agreeToPrivacy)}
                    >
                      Dodaj wyjście na szlak
                    </button>
                  </div>
                
                </div>
              
              )}
  
  
            </div>
                                   
            </CSSTransition>
          </SwitchTransition>
  
        </div>
  
        {step < 3 && (
          <div className={styles['btn-next-wrapper']}>
            <span
              role="button"
              tabIndex={0}
              className={`${styles['btn-next']} ${isCurrentStepValid ? styles.show : styles.hide}`}
              onClick={() => {
                if (isCurrentStepValid) {
                  setStep(step + 1)
                }
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && isCurrentStepValid) {
                  setStep(step + 1)
                }
              }}
            >
              Dalej →
            </span>
          </div>
        )}
  
      </form>
  
    </div>
    
  )
}

export default HikeAdd